import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useSearchParams, Link,useNavigate, createSearchParams } from 'react-router-dom';
import Loading from "./Loading";
import { setSAMLLogin } from "../reducers/auth";
import { Typography, Box } from "@mui/material";
import { fetchGlobalSettings, globalsettingSet } from "../reducers/reference_settings";
import { getLanding } from "../actions/viewinstance";
import { userTimeoutSecondsRemaining } from "../reducers/auth_timeout";
const SAML = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const [auth, setAuth] = useState("")
    const [responseGuid, setResponseGuid] = useState("")
    const [error, setError] = useState("")



    useEffect(() => {
        if(searchParams.get('AuthToken')){
            setError("")
            
            setAuthinRedux(searchParams.get('AuthToken'))
        } else {
            setError("")
        }
        
    }, [])

    useEffect(() => {
        //after auth, set response guid  
        if(auth){
            const destination = (searchParams.get('Page') || 'home').toLowerCase()
            //hra/pr/ps setRespnseGuid

            if(searchParams.get('assmtguid')){
                callSetResponseGuid(searchParams.get('assmtguid'))
            } else {
                if(destination=="hra2"){
                    //handle start
                    handleStart()
                } else if(destination=="healthshelf") {
                    if(!searchParams.get('hsg'))
                    {
                        navigate({ pathname: '/healthshelf' }, { replace: true })
                    }else{

                        navigate({ pathname: '/healthshelfarticle', search: createSearchParams({ hsg: searchParams.get('hsg') }).toString() }, { replace: true })
                    }
                }
                else {
                    navigate('/'+destination, { replace: true })
                }
            }
            //home redirect
            
        }

    }, [auth])

    useEffect(() => {
        if(auth && responseGuid){
            const destination = (searchParams.get('Page') || 'home').toLowerCase()
            if(destination == 'personalreport'){
                navigate({ pathname: '/personalreport', search: createSearchParams({ vi: '8AC17D1E-2871-44D9-ACC0-867285149337' }).toString() }, { replace: true })
            }
            if(destination == 'physiciansummary'){
                navigate({ pathname: '/physiciansummary', search: createSearchParams({ vi: '2C2870C1-1C00-4E67-98FF-04BA402C6824' }).toString() }, { replace: true })
            }
            if(destination == 'hra2'){
                navigate({ pathname: '/hra', search: createSearchParams({ vi: 'D58CC25B-BB6A-439D-B3D7-BA37AD1AB701', assmtguid: responseGuid }).toString() }, { replace: true })
            }
        }
        
    }, [responseGuid])

    const callSetResponseGuid = (responseGuid) => {
        fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + auth + '/RESPONSE%20GUID/' + responseGuid+'/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }
        })
        .then(response => response.json())
        .then(response => {
            setResponseGuid(responseGuid)
        } )
    }

    const handleStart = () => {
        fetch('../../WsWebServicePlatform/Participant/SessionVar/Delete/' + auth + '/RESPONSE%20GUID/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }
        })
        .then(response => response.json())
        .then(response => {
            navigate({ pathname: '/hra', search: createSearchParams({ vi: 'D58CC25B-BB6A-439D-B3D7-BA37AD1AB701' }).toString() }, { replace: true })
        } )
    }

    const setAuthinRedux = (authToken) => {
        let isAdmin = searchParams.get('IsAdmin') || false
        let groupGuid = searchParams.get('GroupGuid') 
   
        localStorage.setItem("group", searchParams.get("GroupGuid"))
        fetch('../../WsWebServiceWellSuite/GetViewInstancePublic/' + groupGuid + '/-1/4F60657A-324B-415C-986A-4ADFD91EBEC2/', {
            method: "GET"
        })
        .then(response => response.json())
        .then( rs => {
            

            let rsps = rs.Info[0].ViewInstanceData
 
            if (rsps.length>0 && rsps[1].SessionVariableValues){
                dispatch(globalsettingSet({SettingFamilyKeyName:"session", Settings:rsps[1].SessionVariableValues}))
                dispatch(globalsettingSet({SettingFamilyKeyName:"organization", Settings:rsps[1].OrganizationSettingValues}))            
            }
            
        }
        )
        .then( rsp=> {
            dispatch(setSAMLLogin({AuthToken: authToken, IsAdmin: isAdmin, GroupGuid: groupGuid}))
        
        setAuth(authToken)
        }
        ).then(rr=> rr.json()).then(rr2=>dispatch(userTimeoutSecondsRemaining()))
    }


    return <Box>
        <Loading />
        {error && 
            <Typography>{error}</Typography>}
        </Box>

};

export default SAML;
